import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    SearchInput,
    EditButton,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import ShipmentShow from '../shipments/ShipmentShow'
import jwt_decode from 'jwt-decode'
import ErrorBoundary from '../ErrorBoundary';

const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const ReadyToShipFilters = props => (
    <Filter {...props}>
        <SearchInput source="case_no" alwaysOn  placeholder='Case Number'/>
        <DateInput source="bleed_date" locales="en-us"/>
        <TextInput source="ucn" lable="Unit Control Number" />
        <TextInput source="ssn" lable="SSN" />  
        <TextInput source="name" lable="Name" />        
    </Filter>
);

export const ReadyToShipList = props => (
    <ErrorBoundary>
    <List 
        {...props}
        filters={<ReadyToShipFilters />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'DESC' }}
        bulkActionButtons ={false}
        title= "Ready to ship list"
        >
        <Datagrid    expand={<ShipmentShow />} >
            
            <TextField source="case_no" label="Case#" />      
            <TextField source="ucn" label="Unit Control#" />
            <TextField source="name" lablel="Name"/>
            <DateField source="bleed_date" lablel="Bleed Date" locales="en-us" />
            <TextField source="shipping_case_no" label="Ship Case#" />
            <DateField source="shipping_date" lablel="Shipping Date" locales="en-us" />
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 3  && <EditButton label="Update Shipping" />}
        </Datagrid>
    </List>
    </ErrorBoundary>
);


export default ReadyToShipList